import { ConvexReactClient } from "convex/react";
import { env } from "@/env";
import { wireConvexAuth } from "./auth";
import {
  recoverUnavailableSession,
  refreshOnAuthFlip,
  sessionStore,
} from "./session";

export const convex = new ConvexReactClient(env.VITE_CONVEX_URL);
wireConvexAuth(convex, refreshOnAuthFlip(sessionStore.refresh));
recoverUnavailableSession({ store: sessionStore, convex });
